import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { map, Observable } from 'rxjs';
import { Plans, PlanProductModel, TokensPackProductModel } from '../models/products.models';
import { TokensPack } from '../class/tokensPack.class';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  constructor(
    private http:HttpClient
  ) { }

  getProducts():Observable<{plans: Plans, tokensPack: TokensPack[]}>{
    const url:string = `${environment.apiUrl}/stripe/products`;
    return this.http.get<{plans: PlanProductModel[], tokenPacks: PlanProductModel[]}>(url).pipe(
      map((response: { plans: any[], tokenPacks: any[] }) => {

        const plansByName = response.plans.reduce((acc, plan) => {
          acc[plan.name.toLowerCase()] = plan;
          return acc;
        }, {} as Record<string, PlanProductModel>);

        const products: Plans = {
          classic: plansByName['classic'] || null,
          premium: plansByName['premium'] || null,
          entreprise: plansByName['entreprise'] || null,
        }

        const tokensPack: TokensPack[] = (response.tokenPacks || []).map((tokenPack:TokensPackProductModel) => new TokensPack(tokenPack));
        return { plans: products, tokensPack: tokensPack };
      })
    )
  }
}
